/* import __COLOCATED_TEMPLATE__ from './circuit-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import ConfigurationData from '../data/configurationdata';

export default class CircuitPanel extends Component {
    tagName = '';

    @service('data') model;
    @service circuitConfigurations;
    @service tabService;

    svgReplacements = ConfigurationData.svgReplacements;
    svgHiddenGroups = ConfigurationData.svgHiddenGroups;

    @computed('circuitConfigurations.currentCircuitConfig.svg') get svgLocation() {
        let svgName = this.circuitConfigurations.currentCircuitConfig.svg;
        return svgName ? `circuit-configurations/${svgName}.svg` : null;
    }
}
